<template>
	<div class="w-full px-5 relative">
		<div class="
			absolute top-0
			w-full h-70 
			-mx-5 
			-z-1 
			"
			:style="gradient != null ? `--color-uaqi-level: var(--color-uaqi-${gradient}` : ''"
			:class="gradient != null ? 'gradient' : ''"
		></div>

		<div class="w-full mx-auto" :class="sizes[size]">
			<slot></slot>
		</div>
	</div>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
	size: {
		type: String,
		default: "default"
	},
	gradient: {
		required: false,
	}
})

const sizes = {
	default: "max-w-[56em]",
	narrow: "max-w-[24em]",
	full: "max-w-full"
}
</script>

<style scoped>
.gradient {
	background: linear-gradient(to bottom, hsl(from var(--color-uaqi-level) h s calc(l + 15)), transparent);

	animation: fadeIn 0.5s ease-in-out forwards;
}

.dark .gradient {
	background: linear-gradient(to bottom, var(--color-uaqi-level), transparent);
}

@keyframes fadeIn {
	0% {
		opacity: 0;
	}

	100% {
		opacity: 0.5;
	}
}
</style>